import { CommonModule, DatePipe } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  DxDataGridModule,
  DxPopupModule,
  DxDateBoxModule,
  DxNumberBoxModule,
  DxSelectBoxModule,
  DxCheckBoxModule,
  DxTemplateModule,
  DxTagBoxModule,
  DxHtmlEditorModule,
  DxTextAreaModule,
  DxFormModule,
  DxTextBoxModule,
  DxButtonModule,
  DxValidatorModule,
  DxValidationSummaryModule,
  DxListModule,
} from 'devextreme-angular';
import { DxoHeaderFilterModule } from 'devextreme-angular/ui/nested';
import { HhsgSharedStuderEditOrganizationComponent } from "../studer/organization/edit-organization.component";
import { HhsgSharedStuderOrganizationComponent } from "../studer/organization/organization.component";
import { ActiveFilter } from './active-filter.transform';
import { HhsgSharedAdminComponent } from "./admin.component";
import { HhsgSharedClientAdminComponent } from "./client-admin/client-admin.component";
import { ContactHasAppFilter } from "./client-admin/contact-has-app-filter.transform";
import { HhsgSharedEditClientComponent } from "./client-admin/edit-client.component";
import { HhsgSharedNotificationAdminComponent } from "./notification-admin/notification-admin.component";
import { HHSGSharedSearchableSingleSelectboxComponent } from '../admin/notification-admin/searchable-single-selectbox/searchable-single-selectbox.component';
import { HHSGSharedSearchableMultiSelectboxComponent } from '../admin/notification-admin/searchable-multi-selectbox/searchable-multi-selectbox.component';
import { HHSGSharedRichTextBoxComponent } from '../admin/notification-admin/rich-text-box/rich-text-box.component';
import { HhsgSharedAddNotificationComponent } from './notification-admin/add-notification.component';
import { HhsgSharedUserAdminComponent } from './user-admin/user-admin.component';
import { HhsgSharedEditUserComponent } from "./user-admin/edit-user.component";
import { HhsgSharedCommonModule } from "../common/common.module";
import { MaterialDesignModule } from '../../material-design/material-design.module';
import { HhsgSharedMaterialEditUserComponent } from './user-admin/material-edit-user.component';
import { HhsgSharedGenericImporterComponent } from './generic-importer/generic-importer.component';

@NgModule({    
    declarations: [
        ActiveFilter,        
        ContactHasAppFilter,
        HhsgSharedAdminComponent,
        HhsgSharedClientAdminComponent,   
        HhsgSharedEditClientComponent,
        HhsgSharedStuderEditOrganizationComponent,
        HhsgSharedStuderOrganizationComponent,
        HhsgSharedNotificationAdminComponent,
        HHSGSharedSearchableSingleSelectboxComponent,
        HHSGSharedSearchableMultiSelectboxComponent,
        HHSGSharedRichTextBoxComponent,
        HhsgSharedAddNotificationComponent,
        HhsgSharedUserAdminComponent,
        HhsgSharedEditUserComponent,
        HhsgSharedMaterialEditUserComponent,
        HhsgSharedGenericImporterComponent
    ],
    exports: [ 
        HHSGSharedRichTextBoxComponent,
        HhsgSharedUserAdminComponent,
	    HhsgSharedClientAdminComponent,
        HhsgSharedMaterialEditUserComponent,
        HhsgSharedGenericImporterComponent
    ],
    imports: [
        CommonModule,
        DxDateBoxModule,
		DxDataGridModule,
		DxPopupModule,
		DxoHeaderFilterModule,
        FormsModule,
        HhsgSharedCommonModule,
        ReactiveFormsModule,
        RouterModule,
        DxNumberBoxModule, 
		DxCheckBoxModule, 
		DxSelectBoxModule,
		DxTemplateModule,
    	DxTagBoxModule,
		DxHtmlEditorModule,
        MaterialDesignModule,
        DxTextAreaModule,
        DxFormModule,
        DxSelectBoxModule,
        DxCheckBoxModule,
        DxTextBoxModule,
        DxDateBoxModule,
        DxButtonModule,
        DxValidatorModule,
        DxValidationSummaryModule,
        DxListModule
    ],
    providers: [ DatePipe ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HhsgSharedAdminModule {}
